"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSectionExecutivePaperKindCommand = exports.SetSectionB5PaperKindCommand = exports.SetSectionA6PaperKindCommand = exports.SetSectionA5PaperKindCommand = exports.SetSectionA4PaperKindCommand = exports.SetSectionFolioPaperKindCommand = exports.SetSectionLegalPaperKindCommand = exports.SetSectionLetterPaperKindCommand = exports.SetSectionPaperKindCommand = exports.SetSectionPageSizeCommand = void 0;
var tslib_1 = require("tslib");
var section_properties_history_items_1 = require("../../../core/model/history/items/section-properties-history-items");
var paper_kind_1 = require("../../../core/model/section/paper-kind");
var client_command_1 = require("../client-command");
var section_properties_command_base_1 = require("./section-properties-command-base");
var SetSectionPageSizeCommand = (function (_super) {
    tslib_1.__extends(SetSectionPageSizeCommand, _super);
    function SetSectionPageSizeCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionPageSizeCommand.prototype.executeCore = function (_state, options) {
        var parameters = options.param;
        var modelManipulator = this.modelManipulator;
        var history = this.history;
        var iter = this.getAffectedSectionsIterator(options.intervalsInfo.intervals);
        var newLandscape = parameters.size.width > parameters.size.height;
        var changed = false;
        history.beginTransaction();
        while (iter.moveNext()) {
            var sectionInterval = iter.obj.interval;
            var secProps = iter.obj.sectionProperties;
            var oldLandscape = secProps.landscape;
            if (parameters.updateOrientation && oldLandscape !== newLandscape) {
                history.addAndRedo(new section_properties_history_items_1.SectionLandscapeHistoryItem(modelManipulator, sectionInterval, newLandscape));
                changed = true;
            }
            var newWidth = parameters.updateOrientation || !oldLandscape ? parameters.size.width : parameters.size.height;
            if (secProps.pageWidth !== newWidth) {
                history.addAndRedo(new section_properties_history_items_1.SectionPageWidthHistoryItem(modelManipulator, sectionInterval, newWidth));
                changed = true;
            }
            var newHeigth = parameters.updateOrientation || !oldLandscape ? parameters.size.height : parameters.size.width;
            if (secProps.pageHeight !== newHeigth) {
                history.addAndRedo(new section_properties_history_items_1.SectionPageHeightHistoryItem(modelManipulator, sectionInterval, newHeigth));
                changed = true;
            }
            var newPaperKind = parameters.paperKind;
            if (secProps.paperKind !== newPaperKind) {
                history.addAndRedo(new section_properties_history_items_1.SectionPaperKindHistoryItem(modelManipulator, sectionInterval, newPaperKind));
                changed = true;
            }
        }
        history.endTransaction();
        return changed;
    };
    SetSectionPageSizeCommand.prototype.getStateValue = function (_options) {
        return this.inputPosition.getMergedSectionPropertiesRaw().pageSize;
    };
    SetSectionPageSizeCommand.compareSizeByTwoDimensions = function (a, b) {
        return a.equals(b) || a.width == b.height && a.height == b.width;
    };
    return SetSectionPageSizeCommand;
}(section_properties_command_base_1.SectionPropertiesCommandBase));
exports.SetSectionPageSizeCommand = SetSectionPageSizeCommand;
var SetSectionPaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionPaperKindCommand, _super);
    function SetSectionPaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionPaperKindCommand.prototype.DEPRECATEDConvertOptionsParameter = function (_parameter) {
        var paperKind = this.getPaperKind();
        var newSize = paper_kind_1.PaperSizeConverter.calculatePaperSize(paperKind);
        var currentSize = this.inputPosition.getMergedSectionPropertiesRaw().pageSize;
        var equal = SetSectionPageSizeCommand.compareSizeByTwoDimensions(currentSize, newSize);
        return equal ? { size: currentSize, updateOrientation: false, paperKind: paperKind } : { size: newSize, updateOrientation: false, paperKind: paperKind };
    };
    SetSectionPaperKindCommand.prototype.getStateValue = function (_options) {
        var newSize = paper_kind_1.PaperSizeConverter.calculatePaperSize(this.getPaperKind());
        var currentSize = this.inputPosition.getMergedSectionPropertiesRaw().pageSize;
        return SetSectionPageSizeCommand.compareSizeByTwoDimensions(newSize, currentSize) ? currentSize : null;
    };
    SetSectionPaperKindCommand.prototype.getStateCore = function (enabled, intervals, value) {
        var state = _super.prototype.getStateCore.call(this, enabled, intervals, value);
        state.checked = value !== null;
        return state;
    };
    SetSectionPaperKindCommand.prototype.getRelatedCommands = function () {
        var _a;
        return _a = {},
            _a[client_command_1.RichEditClientCommand.SetSectionLetterPaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionLegalPaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionFolioPaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionA4PaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionA5PaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionA6PaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionB5PaperKind] = true,
            _a[client_command_1.RichEditClientCommand.SetSectionExecutivePaperKind] = true,
            _a;
    };
    return SetSectionPaperKindCommand;
}(SetSectionPageSizeCommand));
exports.SetSectionPaperKindCommand = SetSectionPaperKindCommand;
var SetSectionLetterPaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionLetterPaperKindCommand, _super);
    function SetSectionLetterPaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionLetterPaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.Letter; };
    return SetSectionLetterPaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionLetterPaperKindCommand = SetSectionLetterPaperKindCommand;
var SetSectionLegalPaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionLegalPaperKindCommand, _super);
    function SetSectionLegalPaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionLegalPaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.Legal; };
    return SetSectionLegalPaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionLegalPaperKindCommand = SetSectionLegalPaperKindCommand;
var SetSectionFolioPaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionFolioPaperKindCommand, _super);
    function SetSectionFolioPaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionFolioPaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.Folio; };
    return SetSectionFolioPaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionFolioPaperKindCommand = SetSectionFolioPaperKindCommand;
var SetSectionA4PaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionA4PaperKindCommand, _super);
    function SetSectionA4PaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionA4PaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.A4; };
    return SetSectionA4PaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionA4PaperKindCommand = SetSectionA4PaperKindCommand;
var SetSectionA5PaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionA5PaperKindCommand, _super);
    function SetSectionA5PaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionA5PaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.A5; };
    return SetSectionA5PaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionA5PaperKindCommand = SetSectionA5PaperKindCommand;
var SetSectionA6PaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionA6PaperKindCommand, _super);
    function SetSectionA6PaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionA6PaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.A6; };
    return SetSectionA6PaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionA6PaperKindCommand = SetSectionA6PaperKindCommand;
var SetSectionB5PaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionB5PaperKindCommand, _super);
    function SetSectionB5PaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionB5PaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.B5; };
    return SetSectionB5PaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionB5PaperKindCommand = SetSectionB5PaperKindCommand;
var SetSectionExecutivePaperKindCommand = (function (_super) {
    tslib_1.__extends(SetSectionExecutivePaperKindCommand, _super);
    function SetSectionExecutivePaperKindCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SetSectionExecutivePaperKindCommand.prototype.getPaperKind = function () { return paper_kind_1.PaperKind.Executive; };
    return SetSectionExecutivePaperKindCommand;
}(SetSectionPaperKindCommand));
exports.SetSectionExecutivePaperKindCommand = SetSectionExecutivePaperKindCommand;
